"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPackingSlip = getPackingSlip;
exports.packingSlips = void 0;
require("core-js/modules/es.array.slice.js");
var _mttPostal = _interopRequireDefault(require("@gaming/mtt-postal"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function getPackingSlip(type /*, env */) {
  if (Object.prototype.hasOwnProperty.call(packingSlips, type)) {
    return packingSlips[type].apply(this, Array.prototype.slice.call(arguments, 1));
  }
}
var packingSlips = {
  ping: function ping() {
    return {
      type: "federation.ping",
      instanceId: _mttPostal.default.instanceId(),
      timeStamp: new Date(),
      ticket: _mttPostal.default.createUUID()
    };
  },
  pong: function pong(ping) {
    return {
      type: "federation.pong",
      instanceId: _mttPostal.default.instanceId(),
      timeStamp: new Date(),
      pingData: {
        instanceId: ping.instanceId,
        timeStamp: ping.timeStamp,
        ticket: ping.ticket
      }
    };
  },
  message: function message(env) {
    return {
      type: "federation.message",
      instanceId: _mttPostal.default.instanceId(),
      timeStamp: new Date(),
      envelope: env
    };
  },
  disconnect: function disconnect() {
    return {
      type: "federation.disconnect",
      instanceId: _mttPostal.default.instanceId(),
      timeStamp: new Date()
    };
  },
  bundle: function bundle(packingSlips) {
    return {
      type: "federation.bundle",
      instanceId: _mttPostal.default.instanceId(),
      timeStamp: new Date(),
      packingSlips: packingSlips
    };
  }
};
exports.packingSlips = packingSlips;